<!-- add-payment.component.html (DROP-IN: Square Web Payments SDK) -->
<div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg shadow-lg w-full max-w-md mx-4">
    <!-- Header -->
    <div
      class="flex items-center justify-between px-6 py-2 border-b border-gray-200"
    >
      <h2 class="text-lg font-semibold text-gray-900">
        {{ mode === "edit" ? "Edit Payment" : "Add Payment" }}
      </h2>

      <button
        type="button"
        autofocus="false"
        (click)="onClose()"
        [disabled]="isSubmitting"
        class="text-gray-400 hover:text-gray-600 transition-colors disabled:opacity-50"
      >
        ✖
      </button>
    </div>

    <!-- Error Message -->
    <div
      *ngIf="errorMessage"
      class="mx-6 mt-4 p-3 bg-red-50 border border-red-200 rounded-lg"
    >
      <p class="text-red-600 text-sm">{{ errorMessage }}</p>
    </div>

    <!-- Form -->
    <form (ngSubmit)="handleSubmit()" class="p-6 space-y-4">
      <!-- First Name -->
      <div>
        <label class="block text-sm font-medium text-gray-900 mb-2">
          First name<span class="text-red-500"> *</span>
        </label>

        <input
          type="text"
          [(ngModel)]="formData.firstName"
          name="firstName"
          placeholder="First name"
          [disabled]="isSubmitting"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white text-gray-900 disabled:bg-gray-100 disabled:cursor-not-allowed"
        />

        <span class="text-red-500 text-sm" *ngIf="!validations.FirstName">
          First Name is required
        </span>
      </div>

      <!-- Last Name -->
      <div>
        <label class="block text-sm font-medium text-gray-900 mb-2">
          Last Name<span class="text-red-500"> *</span>
        </label>

        <input
          type="text"
          [(ngModel)]="formData.lastName"
          name="lastName"
          placeholder="Last name"
          [disabled]="isSubmitting"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white text-gray-900 disabled:bg-gray-100 disabled:cursor-not-allowed"
        />

        <span class="text-red-500 text-sm" *ngIf="!validations.LastName">
          Last Name is required
        </span>
      </div>

      <!-- Card Details (Square-hosted fields; no PAN/CVC in your app) -->
      <div *ngIf="mode !== 'edit'">
        <label class="block text-sm font-medium text-gray-900 mb-2"
          >Card Details</label
        >

        <div class="px-4 py-3 border border-gray-300 rounded-lg bg-white">
          <!-- Square mounts its secure card UI here -->
          <div id="square-card-container" #squareCardContainer></div>
        </div>

        <!-- Small helper text -->
        <p class="text-xs text-gray-500 mt-2">
          Card details are securely handled by Square. We don't store your full
          card number.
        </p>

        <!-- Optional: show validation error if Square field isn't ready/valid -->
        <span class="text-red-500 text-sm" *ngIf="!validations.SquareCardReady">
          Please enter valid card details.
        </span>
      </div>

      <!-- Edit Mode: show saved card summary (you can't edit card number/expiry/cvc) -->
      <div
        *ngIf="mode === 'edit' && existingCardSummary"
        class="p-3 border border-gray-200 rounded-lg bg-gray-50"
      >
        <p class="text-sm text-gray-900 font-medium">Current card</p>
        <p class="text-sm text-gray-700 mt-1">{{ existingCardSummary }}</p>
        <p class="text-xs text-gray-500 mt-2">
          To change the card number, add a new card instead (Square does not
          allow editing a saved card's number/CVC).
        </p>
      </div>

      <!-- Checkbox -->
      <div class="flex items-center gap-2 pt-2">
        <input
          type="checkbox"
          [(ngModel)]="formData.isPrimary"
          name="isPrimary"
          id="isPrimary"
          [disabled]="isSubmitting"
          class="w-4 h-4 rounded border-gray-400 cursor-pointer disabled:cursor-not-allowed"
        />
        <label for="isPrimary" class="text-sm text-gray-900 cursor-pointer">
          Set as primary
        </label>
      </div>

      <!-- Buttons -->
      <div class="flex gap-3 pt-6">
        <button
          type="button"
          (click)="onClose()"
          [disabled]="isSubmitting"
          class="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-900 hover:bg-gray-100 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Back
        </button>

        <button
          type="submit"
          [disabled]="isSubmitting"
          class="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:opacity-90 transition-opacity font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
        >
          <span *ngIf="!isSubmitting">{{
            mode === "edit" ? "Update" : "Add"
          }}</span>

          <span *ngIf="isSubmitting" class="flex items-center gap-2">
            <svg
              class="animate-spin h-4 w-4 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            Processing...
          </span>
        </button>
      </div>
    </form>
  </div>
</div>
